export const instance = [];

export function AT_openBrWindow(index, theURL, winName, features) {
	if (!instance[index] || instance[index].closed) {
		instance[index] = window.open(theURL, winName, features);
	} else {
		instance[index].location.href = theURL;
		instance[index].focus();
    }
    window.NewindexPopup = instance;
};

export function closeAll() {
    if (instance.length > 0) {
        for (let i = 0; i < instance.length; i++) {
            if ((i === 3 || i === 4) && instance[i]) {
                for (let k = 0; k < instance[i].length; k++) {
                    if (instance[i][k] && !instance[i][k].closed) {
                        instance[i][k].close();
                    }
                }
            } else {
                if (instance[i] && !instance[i].closed) {
                    instance[i].close();
                }
            }
        }
    }
    window.NewindexPopup = null;
}